module.exports = __webpack_public_path__ + "static/media/n_icon_right_arrow@2x.ffc82591.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_right_arrow@2x.png
// module id = 1810
// module chunks = 0 1